import { actionsFactory, props } from '@ngneat/effects';
import { AddOn, UserImport } from '@tmx/data-access';
import { ClientOnlyScope, ClientOnlyValue } from '@tmx/operandi';

import { FilterAssetsSelectOption } from '../../features/assets/components/filter-assets-dropdown/models/filter-assets-select-option';
import { LicenseProduct } from '../../models/license-product';
import { LicenseUser } from '../../models/license-user';

const assetsActions = actionsFactory('assets');

export const loadAssets = assetsActions.create('Load Assets');

export const loadFleetData = assetsActions.create(
  'Load Fleet Data',
  props<{ externalIds: string[] }>()
);

export const loadSingleAssetDriverData = assetsActions.create(
  'Load Single Asset Driver Data',
  props<{ vehicleId: string }>()
);

export const reloadAssets = assetsActions.create('Reload Assets');

export const setAssetsOffset = assetsActions.create(
  'Set Assets Offset',
  props<{ offset: number }>()
);

export const setAssetsSort = assetsActions.create(
  'Set Assets Sort Properties',
  props<{ sortDirection: '' | 'asc' | 'desc'; sortExpression: string }>()
);

export const setAssetsQuery = assetsActions.create(
  'Set Assets Query',
  props<{ query: string }>()
);

export const setFilterAssetsSelectOption = assetsActions.create(
  'Set Filter Assets Select Option',
  props<{ filterAssetsSelectOption: FilterAssetsSelectOption | null }>()
);

export const selectAsset = assetsActions.create(
  'Select Asset',
  props<{ asset: LicenseUser; checked: boolean }>()
);

export const importAssets = assetsActions.create(
  'Import List Of Assets',
  props<{ assets: UserImport[] }>()
);

export const clearImportResponse = assetsActions.create(
  'Clear Import Response'
);

export const selectAllAssets = assetsActions.create(
  'Select All Assets',
  props<{ scope: ClientOnlyScope; value: ClientOnlyValue }>()
);

export const refreshAssetsRowsDescriptor = assetsActions.create(
  'Refresh Assets Rows Descriptor'
);

export const clearSelectedAssets = assetsActions.create(
  'Clear Selected Assets'
);

export const clearSingleAssetDriverData = assetsActions.create(
  'Clear Single Asset Driver Data'
);

export const loadUsersCsv = assetsActions.create('Load Users Csv File');

export const clearAssets = assetsActions.create('Clear Assets');

export const setFilterByAssetIds = assetsActions.create(
  'Set Filter By Asset Ids',
  props<{ filterByAssetIds: string[] }>()
);

export const loadHistoricalNotifications = assetsActions.create(
  'Load Historical Notifications',
  props<{ externalId: string }>()
);

export const inviteSamsaraUser = assetsActions.create(
  'Invite Samsara User To Product',
  props<{ asset: LicenseUser; product: LicenseProduct }>()
);

export const inviteSamsaraUsers = assetsActions.create(
  'Invite Samsara Users To All Products Associated With Their Asset',
  props<{ assets: LicenseUser[] }>()
);

export const checkIfAssetIsDeleted = assetsActions.create(
  'Check If Asset Is Deleted',
  props<{ externalId: string }>()
);

export const checkIfAssetIsCreated = assetsActions.create(
  'Check If Asset Is Created',
  props<{ externalId: string }>()
);

export const checkIfAssetIsChanged = assetsActions.create(
  'Check If Asset Is Changed',
  props<{ asset: LicenseUser; externalId: string }>()
);

export const loadCopilotVersions = assetsActions.create(
  'Load CoPilot Versions'
);

export const loadMapDataVersions = assetsActions.create(
  'Load Map Data Versions'
);

export const selectAllBulkAssign = assetsActions.create(
  'Select All Bulk Assign',
  props<{
    addons: AddOn[];
    productId: number;
  }>()
);

export const selectAllBulkUnassign = assetsActions.create(
  'Select All Bulk Unassign',
  props<{
    addons: AddOn[];
    productId: number;
  }>()
);

export const selectAllBulkInvite = assetsActions.create(
  'Select All Bulk Invite',
  props<{
    inviteLanguage: string;
    samsaraMessageEnabled: boolean;
  }>()
);

export const selectAllBulkNotify = assetsActions.create(
  'Select All Bulk Notify',
  props<{
    message: string;
  }>()
);

export const selectAllBulkResetPassword = assetsActions.create(
  'Select All Bulk Reset Password',
  props<{
    forcePasswordReset: boolean;
    password: string;
  }>()
);

export const selectAllBulkDelete = assetsActions.create(
  'Select All Bulk Delete'
);

export const clearJobTraceId = assetsActions.create('Clear Job Trace Id');
